import React, { memo,  useContext } from 'react';

import { SidebarBase } from '../SidebarBase/SidebarBase';
import { SidebarContext } from '../PageLayout/ContextProvider';
import { AdditionalInfoContent } from './AdditionalInfoContent/AdditionalInfoContent';

export const AdditionalInfoSideBar = memo(({ navigationBarVisibility }) => {
    const {
        sidebarVisibility: { additionalInfoSidebar: { visibility = false } = {} },
        handleToggleAdditionalInfoSidebar,
    } = useContext(SidebarContext);

    const handleClose = () => handleToggleAdditionalInfoSidebar();

    return (
        <SidebarBase visibility={visibility} handleClose={handleClose} anchor="right" navigationBarVisibility={navigationBarVisibility}>
            <AdditionalInfoContent />
        </SidebarBase>
    );
});

AdditionalInfoSideBar.displayName = 'AdditionalInfoSideBar';
